<template>
  <v-layout wrap row>
    <v-flex xs5 text-xs-center class="pr-3">
      <square-combook-binding-frame
        :cover-thumbnail-url="combookBindingCover.thumbnailUrl"
      ></square-combook-binding-frame>
    </v-flex>

    <v-flex xs7 text-xs-left>
      <div>
        連絡帳製本
        <p class="caption mt-2">
          園・施設名： {{ organization.name }}<br />
          名前： {{ combookBindingCover.kidFullName }} さん<br />
          期間： {{ combookBindingCover.targetPeriodText }}<br />
          表紙デザイン： {{ designTypeLabel }}<br />
          表紙の印字： {{ coverText }}
        </p>
      </div>

      <div class="text-xs-right">
        <v-btn
          flat
          icon
          color="primary"
          :disabled="!canCombookBindingDecrement"
          @click.native="
            $emit('update-combook-binding-order-amount', orderAmount - 1)
          "
        >
          <v-icon :large="$vuetify.breakpoint.name !== 'xs'">
            remove_circle
          </v-icon>
        </v-btn>

        <span
          class="font-weight-bold my-2"
          :class="{ title: $vuetify.breakpoint.name !== 'xs' }"
        >
          {{ orderAmount }} 冊
        </span>

        <v-btn
          flat
          icon
          color="primary"
          :disabled="!canCombookBindingIncrement"
          @click.native="
            $emit('update-combook-binding-order-amount', orderAmount + 1)
          "
        >
          <v-icon :large="$vuetify.breakpoint.name !== 'xs'">
            add_circle
          </v-icon>
        </v-btn>
      </div>

      <ul class="list-vertical text-xs-right">
        <li>
          <a
            href="#"
            class="remove-item-link"
            @click.stop.prevent="$emit('remove-combook-binding-order')"
            >削除する</a
          >
        </li>
      </ul>
    </v-flex>
  </v-layout>
</template>

<script lang="ts">
import SquareCombookBindingFrame from "../../../../../../components/SquareCombookBindingFrame";

import Organization from "../../../../../../models/Organization";
import CombookBindingCover from "../../../../../../models/CombookBindingCover";

import {
  CART_ITEM_MIN_LIMIT,
  CART_ITEM_MAX_LIMIT
} from "../../../../../../models/Cart";

const DESIGN_TYPE_LABELS = {
  pastel: "パステル",
  simple: "シンプル"
};

export default {
  components: {
    "square-combook-binding-frame": SquareCombookBindingFrame
  },
  props: {
    organization: {
      type: Organization,
      required: true
    },
    combookBindingCover: {
      type: CombookBindingCover,
      required: true
    },
    priceMap: {
      type: Map, // Map<number, number>
      required: true
    },
    mediaType: {
      type: Number,
      required: true
    },
    orderAmount: {
      type: Number,
      required: true
    }
  },
  computed: {
    designTypeLabel(): string {
      return DESIGN_TYPE_LABELS[this.combookBindingCover.designType];
    },
    coverText(): string {
      return `${this.combookBindingCover.organizationName} / ${this.combookBindingCover.kidName}`;
    },
    canCombookBindingIncrement() {
      return this.orderAmount < CART_ITEM_MAX_LIMIT;
    },
    canCombookBindingDecrement() {
      return this.orderAmount > CART_ITEM_MIN_LIMIT;
    }
  }
};
</script>

<style scoped>
a.remove-item-link {
  font-size: 12px;
  color: #545454;
  text-decoration: underline;
}
</style>
